import React from 'react';

const Banner = ({ 
  title, 
  backgroundImage = '/default-banner.jpg',
  height = '400px',
  overlay = true,
  className = '',
  responsiveImage  = '/default-banner.jpg',
  mobileImage  = '/default-banner.jpg',
}) => {
  return (
    <div 
    className={`relative w-full flex items-center justify-center font-fira ${className} xxl:mt-[152px] lg:mt-[145px] mt-[100px]
 `} >
    <div className='w-full'>
      <img className='md:block hidden' src={`${backgroundImage}`} />
      <img className='md:hidden xs:block hidden' src={`${responsiveImage}`} />
      <img className='xs:hidden block w-full' src={`${mobileImage}`} />
    </div>
    <div className="absolute flex flex-col justify-center items-center text-center">
      <h1 className="font-bold text-3xl sm:text-4xl md:text-5xl lg:text-[68px] leading-[88px] tracking-0 text-white uppercase">
        {title}
      </h1>
    </div>
  </div>
  
  
  
  
  );
};

export default Banner; 